import React from "react";
import { DurationOptions } from "./constants";
import {
  DurationSelectorContainer,
  DurationOption,
  DurationOptionList,
  DurationLabel,
} from "./styles";
import ReactGA from "react-ga";

function DurationSelector({
  duration,
  setDuration,
  disabled,
  durationOptions = DurationOptions,
}) {
  return (
    <DurationSelectorContainer>
      <DurationLabel>Duration:</DurationLabel>
      <DurationOptionList>
        {Object.keys(durationOptions).map((durationOption, index) => {
          return (
            <DurationOption
              key={index}
              disabled={disabled}
              active={durationOption === duration}
              onClick={() => {
                ReactGA.event({
                  category: "App - Dashboard",
                  action: "Selected Duration",
                  label:durationOption
                });
                !disabled &&
                  durationOption !== duration &&
                  setDuration(durationOption);
              }}
            >
              {durationOption}
            </DurationOption>
          );
        })}
      </DurationOptionList>
    </DurationSelectorContainer>
  );
}
export default DurationSelector;
